import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import SeoHead from "../components/SeoHead";
import { ROUTE_SEO } from "../seo/routes";

const ACCENT = "#5ed29c";

const SUGGESTIONS = [
  { label: "Gradient Descent", to: "/gradient-descent" },
  { label: "Build Your Compiler", to: "/compiler" },
  { label: "Build a Lakehouse", to: "/lakehouse" },
  { label: "Model Context Protocol", to: "/mcp" },
  { label: "LLM VRAM Calculator", to: "/llm-vram-calculator" },
  { label: "AI/ML Architect", to: "/ai-ml-architect" },
];

export default function NotFoundPage() {
  return (
    <>
      <SeoHead {...ROUTE_SEO["/404"]} />

      <main id="main" className="relative isolate flex min-h-[100svh] w-full flex-col overflow-hidden bg-[#070b0a]">
        {/* Pas de vidéo ici : une 404 n'a pas à télécharger 2,4 Mo. Le poster et
            les dégradés suffisent à garder l'identité du hero. */}
        <div aria-hidden className="absolute inset-0 overflow-hidden">
          <img
            src="/hero-poster.jpg"
            alt=""
            width={1280} height={554}
            className="absolute inset-0 h-full w-full object-cover opacity-25"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg, #070b0a 0%, rgba(7,11,10,0.88) 38%, rgba(7,11,10,0.5) 70%, rgba(7,11,10,0.2) 100%)",
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(0deg, #070b0a 0%, rgba(7,11,10,0.6) 20%, transparent 60%)",
            }}
          />
        </div>

        {/* Lignes de grille aux quarts, comme sur le hero */}
        <div aria-hidden className="pointer-events-none absolute inset-0 hidden md:block">
          <span className="hero-grid-line" style={{ left: "25%" }} />
          <span className="hero-grid-line" style={{ left: "50%" }} />
          <span className="hero-grid-line" style={{ left: "75%" }} />
        </div>

        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-6 pb-24 pt-32 sm:px-8 lg:px-12">
          <span className="hero-card-eyebrow">[ 404 ]</span>

          <h1 className="hero-title mt-6">
            Page
            <br />
            Not
            <br />
            Found<span style={{ color: ACCENT }}>.</span>
          </h1>

          <p className="hero-desc mt-7">
            This page doesn't exist, or no longer does. Nothing is broken on your
            side — the address simply leads nowhere.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to="/"
              className="hero-cta-primary group inline-flex items-center gap-2 rounded-full bg-[#5ed29c] px-6 py-3 text-sm font-semibold transition-transform duration-200 hover:scale-[1.03] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#5ed29c]"
            >
              <ArrowLeft
                size={16}
                className="transition-transform duration-200 group-hover:-translate-x-1"
              />
              Back to home
            </Link>
          </div>

          <div className="mt-14 border-t border-white/10 pt-8">
            <p className="exp-section-count mb-5">Or jump to an experience</p>
            <ul className="flex flex-wrap gap-x-8 gap-y-3">
              {SUGGESTIONS.map((s) => (
                <li key={s.to}>
                  <Link
                    to={s.to}
                    className="nav-link group inline-flex items-center gap-1.5 text-[15px]"
                  >
                    {s.label}
                    <ArrowRight
                      size={14}
                      className="opacity-0 transition-all duration-200 group-hover:translate-x-0.5 group-hover:opacity-100"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </main>
    </>
  );
}
